import type { RouteRecordRaw } from 'vue-router';
import type { AccessRolSection, AccessRolAction } from '@/shared/access';
import {
  MAPPED_ACCESS_ROLE_SECTIONS,
  ACCESS_ROLE_ACTIONS,
} from '@/shared/access/constants/access.constant';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');

const ScheduledTransferList = () =>
  import('../pages/ScheduledTransferList/index.vue');

const ScheduledTransferDetail = () =>
  import('../pages/ScheduledTransferDetail/index.vue');

/**
 * Se gatea igual que la ruta productiva de envío (`transactionRoutes`): sección
 * MAPEADA `TRANSACTIONS` + acción `INDIVIDUAL_SEND`, validada contra el array de
 * accesos del backend. Así la lista, el detalle y la eliminación NO quedan
 * alcanzables por URL directa para un rol sin permiso de envío (el gate por
 * `SEND` unmapped sin actions era más débil que el del propio menú).
 */
const ACCESS_ROL: { section: AccessRolSection; actions?: AccessRolAction[] } = {
  section: MAPPED_ACCESS_ROLE_SECTIONS.TRANSACTIONS,
  actions: [ACCESS_ROLE_ACTIONS.INDIVIDUAL_SEND],
};

/**
 * El FLUJO de creación de un envío programado NO tiene ruta propia: se entra
 * desde el `TransactionFlow` (opción "Programar" del selector de tipo) en modo
 * `isScheduled`. Aquí viven la LISTA y el DETALLE, ambos bajo `MainLayout`
 * (header B2B), no bajo el layout vacío.
 */
export const scheduledTransferRoutes: Array<RouteRecordRaw> = [
  {
    path: '/scheduled-transfers',
    component: MainLayout,
    /**
     * `flag` lo lee el guard global `validateFirebaseFeatureFlags`: con el
     * kill-switch apagado, lista y detalle redirigen a `movements` en lugar de
     * quedar alcanzables por URL directa. Vue Router mergea el meta del padre
     * en los hijos, así que declararlo acá cubre las dos rutas.
     */
    meta: { accessRol: ACCESS_ROL, flag: 'feature_scheduled_transfers' },
    children: [
      {
        path: '',
        name: 'scheduled-transfers',
        component: ScheduledTransferList,
      },
      {
        path: ':id',
        name: 'scheduled-transfer-detail',
        component: ScheduledTransferDetail,
      },
    ],
  },
];
